/* Flipbook: a clickable stack of photos. Clicking (or Enter/Space) sends the top
   photo rotating behind the stack, revealing the next one. */
(function () {
  class FlipBook extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.flipbook__card'));
      if (this.cards.length < 2) return;

      this.order = this.cards.slice();
      this.animating = false;

      this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

      this._applyStack();

      this.addEventListener('click', () => this.flip());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.flip();
        }
      });
    }

    _applyStack() {
      const n = this.order.length;
      this.order.forEach((card, i) => {
        card.style.zIndex = String(n - i);
      });
    }

    flip() {
      if (this.animating || this.order.length < 2) return;
      this.animating = true;

      const top = this.order[0];
      const onEnd = () => {
        top.removeEventListener('animationend', onEnd);
        top.classList.remove('is-flipping');
        // move the top card to the back of the stack
        this.order.push(this.order.shift());
        this._applyStack();
        this.animating = false;
      };

      top.addEventListener('animationend', onEnd);
      top.classList.add('is-flipping');

      // Safety fallback in case animationend doesn't fire
      setTimeout(() => {
        if (this.animating && top.classList.contains('is-flipping')) onEnd();
      }, 1200);
    }
  }

  if (!customElements.get('flip-book')) {
    customElements.define('flip-book', FlipBook);
  }
})();
